<div class="info">
    <h2><mat-icon> location_on</mat-icon> Adresses et infos :</h2>
    <em>Je vous reçois dans différents cabinets, uniquement sur rendez-vous</em>
</div>
<div class="container">
    <div *ngFor="let adresse of adresses " class="case" [ngStyle]="{'background-color': this.adresse.color}">
        <div class="titleCase">
            <p>{{this.adresse.nom}}</p>
            <div class="groupBubble">
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
            </div>
        </div>
        <div class="adresse">
            <p><mat-icon> map</mat-icon> Adresse :</p>
            <em>{{this.adresse.rue}}</em><br>
            <em>{{this.adresse.codePost}}</em>
        </div>
        <div class="parking">
            <p><mat-icon>directions_car</mat-icon> Parking :</p>
            <em>{{this.adresse.parking}}</em>
        </div>
        <div class="tel">
            <p><mat-icon> phone</mat-icon> Téléphone :</p>
            <em>{{this.adresse.tel}}</em><br>
            <em>{{this.adresse.fax}}</em>
        </div>
        <div class="bancontact">
            <p><mat-icon>credit_card</mat-icon> Bancontact :</p>
            <em>{{this.adresse.banc}}</em>
        </div>
        <div class="map">
            <iframe [src]="sanitizer.bypassSecurityTrustResourceUrl(this.adresse.mapUrl)" width="300" height="225" frameborder="0" style="border:0;" ></iframe>
        </div>
       
    </div>
</div>
<!-- <footer>
    <div class="footbar"></div>
</footer> -->
